import React from 'react';
import { MOIS_COURTS } from '../utils/constants';
import { genMonths, fmtUnit, UNIT_LABELS } from '../utils/helpers';

// unit : respecte le sélecteur d'unité de la section parente

const BORD_H   = '1px solid rgba(255,255,255,0.2)';
const BORD_D   = '1px solid #dedad6';
const BORD_SEP = '2px solid #c8c8c8';   // séparateur col TOTAL et col label
const TH_GRAY  = { background: '#808080', color: '#fff',    padding: '6px 9px', textAlign: 'center', fontWeight: 700, fontSize: '0.68rem', whiteSpace: 'nowrap', borderTop: BORD_H, borderBottom: BORD_H, borderLeft: BORD_H, borderRight: BORD_H };
const TD_R     = { background: '#ffffff', color: '#1a1a1a', padding: '6px 9px', textAlign: 'center', fontWeight: 600, fontSize: '0.72rem', borderTop: BORD_D, borderBottom: BORD_D, borderLeft: BORD_D, borderRight: BORD_D };
const TD_B     = { background: '#f7f6f4', color: '#444444', padding: '6px 9px', textAlign: 'center', fontWeight: 400, fontSize: '0.72rem', borderTop: BORD_D, borderBottom: BORD_D, borderLeft: BORD_D, borderRight: BORD_D };
const TD_PCT   = { background: '#efefee', color: '#333333', padding: '6px 9px', textAlign: 'center', fontWeight: 700, fontSize: '0.72rem', borderTop: BORD_D, borderBottom: '2px solid #c8c8c8', borderLeft: BORD_D, borderRight: BORD_D };

const TableauMensuel = ({ graphique, debut, fin, onCellClick, dataType, onBudgetClick, unit }) => {
  if (!graphique?.labels?.length) return null;

  const months   = genMonths(debut, fin);
  const realisMap = {}, budgetMap = {};
  (graphique.labels || []).forEach((m, i) => {
    realisMap[m] = graphique.realise[i] || 0;
    budgetMap[m] = graphique.budget[i]  || 0;
  });

  const toM   = (v) => { const r = fmtUnit(v, unit); return r === '0' ? '' : r.replace(/ [MkK]$/, '').replace(/,0$/, ''); };
  const pctOf = (r, b) => b > 0 ? `${Math.round((r / b) * 100)}%` : '—';

  const totR = months.reduce((s, m) => s + (realisMap[m] || 0), 0);
  const totB = months.reduce((s, m) => s + (budgetMap[m] || 0), 0);

  const yearLabel = debut?.slice(0,4) === fin?.slice(0,4)
    ? `ANNEE ${debut.slice(0,4)}`
    : `${debut?.slice(0,4)}-${fin?.slice(2,4)}`;

  return (
    <div style={{ marginBottom: 14, borderRadius: 6, border: '2px solid #b8b8b8', overflow: 'hidden' }}>
      <div style={{ textAlign: 'right', fontSize: '0.6rem', color: '#aaa', padding: '2px 8px 0', fontStyle: 'italic', background: '#f5f5f5' }}>{UNIT_LABELS[unit] || 'Auto'}</div>
      <div style={{ overflowX: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', fontSize: '0.72rem', width: 'max-content' }}>
        <thead>
          <tr>
            <th style={{ ...TH_GRAY, textAlign: 'left', background: '#6e6e6e', borderRight: BORD_SEP }}>{yearLabel}</th>
            {months.map(m => (
              <th key={m} style={TH_GRAY}>{MOIS_COURTS[parseInt(m.slice(5,7),10)-1]}</th>
            ))}
            <th style={{ ...TH_GRAY, background: '#6e6e6e', borderLeft: BORD_SEP }}>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ ...TD_R, textAlign: 'left', background: '#e8e7e5', color: '#2a2a2a', fontWeight: 700, borderRight: BORD_SEP, borderLeft: 'none' }}>REALISATIONS</td>
            {months.map(m => (
              <td key={m} style={{ ...TD_R, cursor: onCellClick ? 'pointer' : 'default' }}
                onClick={() => onCellClick && onCellClick(m, dataType)}
                title={onCellClick ? 'Voir le détail' : undefined}>
                {toM(realisMap[m])}
              </td>
            ))}
            <td style={{ ...TD_R, background: '#e8e7e5', color: '#2a2a2a', fontWeight: 700, borderLeft: BORD_SEP, borderRight: 'none' }}>{toM(totR) || 0}</td>
          </tr>
          <tr>
            <td style={{ ...TD_B, textAlign: 'left', background: '#e8e7e5', color: '#444', fontWeight: 600, borderRight: BORD_SEP, borderLeft: 'none' }}>BUDGET</td>
            {months.map(m => (
              <td key={m} style={{ ...TD_B, cursor: onBudgetClick ? 'pointer' : 'default' }}
                onClick={() => onBudgetClick && onBudgetClick(m)}
                title={onBudgetClick ? 'Voir le détail budget' : undefined}>
                {toM(budgetMap[m])}
              </td>
            ))}
            <td style={{ ...TD_B, background: '#e8e7e5', color: '#444', fontWeight: 700, borderLeft: BORD_SEP, borderRight: 'none' }}>{toM(totB) || 0}</td>
          </tr>
          <tr>
            <td style={{ ...TD_PCT, textAlign: 'left', background: '#e8e7e5', color: '#333', fontWeight: 700, borderRight: BORD_SEP, borderLeft: 'none' }}>% OBJECTIF</td>
            {months.map(m => <td key={m} style={TD_PCT}>{pctOf(realisMap[m]||0, budgetMap[m]||0)}</td>)}
            <td style={{ ...TD_PCT, background: '#e8e7e5', color: '#333', fontWeight: 700, borderLeft: BORD_SEP, borderRight: 'none' }}>{pctOf(totR, totB)}</td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default TableauMensuel;
